import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

import InfoItem from "./InfoItem";
import SocialIcon from "./SocialIcon";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const cleanPhoneForLink = (phone = "") => String(phone).replace(/[^\d+]/g, "");

const ContactInfo = ({ data, isAR }) => {
  const settings = useSiteSettings();

  const phone = settings?.phone || data?.info?.details?.phone?.value || "";
  const email = settings?.email || data?.info?.details?.email?.value || "";
  const address = settings?.address || data?.info?.details?.address?.value || "";

  const facebook =
    settings?.facebook_link || data?.info?.social?.facebook || "#";
  const linkedin =
    settings?.linkedin_link || data?.info?.social?.linkedin || "#";

  return (
    <aside className="text-primary flex flex-col justify-between bg-gradient-to-br from-[#DCE8F9] via-[#DFEAFA] to-[#FFFFFF] p-10 md:col-span-2">
      <div>
        <h3 className="text-dark mb-2 text-2xl font-semibold">
          {data?.info?.title}
        </h3>

        <p className="mb-12 text-gray-500">{data?.info?.description}</p>

        <div className="space-y-6">
          <InfoItem
            icon={FaPhoneAlt}
            label={data?.info?.details?.phone?.label}
            value={phone}
            href={phone ? `tel:${cleanPhoneForLink(phone)}` : undefined}
          />

          <InfoItem
            icon={FaEnvelope}
            label={data?.info?.details?.email?.label}
            value={email}
            href={email ? `mailto:${email}` : undefined}
          />

          <InfoItem
            icon={FaMapMarkerAlt}
            label={data?.info?.details?.address?.label}
            value={address}
          />
        </div>
      </div>

      {/* Social */}
      <div className="mt-10">
        <p className="text-dark mb-3 text-sm">
          {isAR ? "تابعنا" : "Follow us"}
        </p>

        <div className="flex gap-3">
          <SocialIcon href={facebook} Icon={FaFacebookF} />
          <SocialIcon href={linkedin} Icon={FaLinkedinIn} />
        </div>
      </div>
    </aside>
  );
};

export default ContactInfo;
